window.muxjs = require('mux.js')
window.shaka = require('shaka-player/dist/shaka-player.compiled.js');